// extracted by mini-css-extract-plugin
module.exports = {"background":"bj_fb","values":"bj_fq"};